module.exports = __webpack_public_path__ + "static/media/capsule_machine_hk.b571dee3.png";